// Filter persistence utility for maintaining filter state across navigation
class FilterPersistence {
  constructor() {
    this.storageKey = 'advancedFilters';
  }

  // Save current filter state to localStorage
  saveFilters(filters) {
    try {
      const serializedFilters = JSON.stringify({
        ...filters,
        timestamp: Date.now()
      });
      localStorage.setItem(this.storageKey, serializedFilters);
      return true;
    } catch (error) {
      console.error('Failed to save filters:', error);
      return false;
    }
  }

  // Load filter state from localStorage
  loadFilters() {
    try {
      const saved = localStorage.getItem(this.storageKey);
      if (!saved) return null;

      const parsed = JSON.parse(saved);
      
      // Check if saved filters are not too old (24 hours)
      if (parsed.timestamp && (Date.now() - parsed.timestamp) > 24 * 60 * 60 * 1000) {
        this.clearFilters();
        return null;
      }

      // Remove timestamp before returning
      const { timestamp, ...filters } = parsed;
      return filters;
    } catch (error) {
      console.error('Failed to load filters:', error);
      this.clearFilters();
      return null;
    }
  }

  // Clear saved filters
  clearFilters() {
    try {
      localStorage.removeItem(this.storageKey);
      return true;
    } catch (error) {
      console.error('Failed to clear filters:', error);
      return false;
    }
  }

  // Get default filter state
  getDefaultFilters() {
    return {
      safetyZones: [],
      minSafetyRating: null,
      reviewTimeRange: 'all',
      customDateRange: { start: null, end: null },
      lastUpdated: null,
      locationTypes: [],
      categories: [],
      neighborhoods: [],
      minRating: null,
      minReviewCount: null,
      hasPhotos: null,
      hasReviews: null,
      verifiedOnly: false,
      distanceRadius: null,
      centerPoint: null
    };
  }

  // Check if filters have active values
  hasActiveFilters(filters) {
    return Object.values(filters).some(val => 
      Array.isArray(val) ? val.length > 0 : 
      val !== null && val !== false && val !== 'all' && 
      (typeof val !== 'object' || (val && (val.start || val.end)))
    );
  }

  // Count active filters
  countActiveFilters(filters) {
    let count = 0;
    Object.entries(filters).forEach(([key, value]) => {
      if (Array.isArray(value) && value.length > 0) count++;
      else if (value !== null && value !== '' && value !== false && value !== 'all') {
        if (typeof value === 'object' && (value.start || value.end)) count++;
        else if (typeof value !== 'object') count++;
      }
    });
    return count;
  }
}

// Export singleton instance
const filterPersistence = new FilterPersistence();
export default filterPersistence;